import { render, staticRenderFns } from "./ServiceProviderClient.vue?vue&type=template&id=73a07ac8"
import script from "./ServiceProviderClient.vue?vue&type=script&lang=js"
export * from "./ServiceProviderClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports